import $ from "jquery";
import Swiper from "swiper/bundle";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

function BannerSmallSlider() {
  var swiper;

  function initializeSwiper() {
    swiper = new Swiper(".js-banner-slider-small", {
      autoplay: {
        delay: 2000,
        disableOnInteraction: false,
      },
      lazy: true,
      loop: true,
      spaceBetween: 60,
      speed: 300,
      slidesPerView: 1,
      pagination: {
        el: ".js-banner-slider-small-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".js-banner-slider-small-next",
        prevEl: ".js-banner-slider-small-prev",
      },
      // キーボード操作
      keyboard: {
        enabled: true,
      },
    });
  }

  function destroySwiper() {
    if (swiper) {
      swiper.destroy();
      swiper = undefined;
    }
  }

  function handleResize() {
    var slideCount = $(".js-banner-slider-small").find(".swiper-slide").length;

    if (slideCount === 1) {
      destroySwiper();
      $(".js-banner-slider-small-control").hide();
    } else {
      if (!swiper) {
        initializeSwiper();
      }
    }
  }
  // 初回実行
  handleResize();

  //再生/停止ボタン
  $(".js-banner-slider-small-stop-button").on("click", function () {
    if (swiper) {
      if ($(this).hasClass("is-pause")) {
        swiper.autoplay.start();
        $(this).removeClass("is-pause");
        $(this).text("停止する");
      } else {
        swiper.autoplay.stop();
        $(this).addClass("is-pause");
        $(this).text("再生する");
      }
    } else {
      // swiper オブジェクトが未定義の場合のエラーハンドリング処理
      console.error("Swiperオブジェクトが初期化されていません。");
    }
  });
}

export { BannerSmallSlider };
